import { render, staticRenderFns } from "./Bibliotheque.vue?vue&type=template&id=15bcfcde&scoped=true"
import script from "./Bibliotheque.vue?vue&type=script&lang=js"
export * from "./Bibliotheque.vue?vue&type=script&lang=js"
import style0 from "./Bibliotheque.vue?vue&type=style&index=0&id=15bcfcde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bcfcde",
  null
  
)

export default component.exports